import i18next from "i18next";
import MainHeaderCell from "components/common/datatable/MainHeaderCell";
import {cellWithTooltip } from "components/common/datatable/EADataGrid";
import React from "react";
import moment from "moment";
import DataTableActions from '../../../../components/common/datatable/DataTableActions';
import { GRID_DETAIL_PANEL_TOGGLE_FIELD } from '@mui/x-data-grid-premium';
import EAIcon from '../../../../components/common/EAIcon';

export const contextInstanceListColumns = (showContextDetail, showDossiers, classes, expandedRowIds) => {
  return [
    {
      field: "contextModelName",
      headerName: i18next.t("context.dataTable.context"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("context.dataTable.context")} />
      ),
      renderCell: (params) => {
        const contextModelName = params.row.instanceInfo?.contextModelName;
        return cellWithTooltip(contextModelName || "—");
      },
    },
    {
      field: "reference",
      headerName: i18next.t("context.dataTable.reference"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("context.dataTable.reference")} />
      ),
      renderCell: (params) => {
        const reference = params.row.instanceInfo?.reference;
        return cellWithTooltip(reference || "—");
      },
    },
    {
      field: "creationDate",
      headerName: i18next.t("context.dataTable.creationDate"),
      flex: 0.1,
      renderHeader: () => (
          <MainHeaderCell name={i18next.t("context.dataTable.creationDate")} />
      ),
      renderCell: (params) => {
        const m = moment(params.value);
        const date = m.isValid()?m.format("DD/MM/YYYY"): i18next.t("context.dataTable.noExpirationDate");
        return cellWithTooltip(date)
      },
    },
    {
      field: "isArchived",
      headerName: i18next.t("active"),
      flex: 0.1,
      renderHeader: () => (
        <MainHeaderCell name={i18next.t("active")} />
      ),
      renderCell: (params) => {
        return cellWithTooltip(params.value?i18next.t("no"):i18next.t("yes"), false)
      },
    },
    {
      field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
      headerName: '',
      headerClassName: 'no-header',
      flex: 0.1,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      renderCell: (params) => {
        const isExpanded = expandedRowIds.includes(params.id);
        return params.row.dossierIds.length && params.row.dossiers.length?
          <div className={classes.detailButton} onClick={() => { showDossiers(params.id)}}>
            <EAIcon icon={isExpanded?'detailButton/on':'detailButton/off'}/>
            <span className={classes.detailText}>{i18next.t('details')}</span>
            <EAIcon icon={'detailButton/arrow'} className={isExpanded?classes.openDetail:classes.closeDetail}/>
          </div>
          :<></>
      },
    },
    {
      field: "action",
      headerName: i18next.t("actions"),
      flex: 0.1,
      sortable: false,
      filterable: false,
      disableExport: true,
      hideSortIcons: true,
      disableReorder: true,
      disableColumnMenu: true,
      disableMultipleSelection: true,
      disableSelectionOnClick: true,
      isRowSelectable: false,
      hideFooterSelectedRowCount: true,
      align: "center",
      renderCell: (params) => {
        return (
          <div className="dt" style={{ textAlign: "center" }}>
            <DataTableActions
              actions={[
                {
                  label: i18next.t("show"),
                  icon: "modify-action",
                  isDisabled: false,
                  action: () => showContextDetail(params.row),
                }
              ]}
            />
          </div>
        );
      },
    },
  ];
};
